import { Service } from '@roc/feature-app-core';

const url = {
  GET_LOAN_PROPERTIES:
    '/api/v1/loan/getLoanPropertiesByLoanId/'
};

class LoanPropertyService extends Service {

  async getLoanProperties(loanId: string, disableGlobalLoading = false) {
    try {
      if (!loanId) return;
      const response: any = await this.get(`${url.GET_LOAN_PROPERTIES}${loanId}`, {}, { disableGlobalLoading });
      return response?.data?.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  }
}

export default new LoanPropertyService();
